export enum SemTalkCookie {
  guilanguage = "guilanguage",
  language = "language",
  simulationtab = "simulation",
  simulationtabeditable = "simulationtabeditable",
  adaptivecard = "adaptivecard",
  webservice = "webservice",
  agentic = "agentic",
  searchtab = "searchtab",
  simtimeoffs = "simtimeoffs",
  bpmn = "bpmn",
  bpmnstencil = "bpmnstencil",
  bpmndialog = "bpmndialog",
  bpmnsymbols = "bpmnsymbols",
  bpmneventtypes = "bpmneventtypes",
  bpmnsfmfrules = "bpmnsfmfrules",
  bpmnmultipleinterfaces = "bpmnmultipleinterfaces",
  epcsymbols = "epcsymbols",
  enforcemanhattan = "enforcemanhattan",
  objectflow = "objectflow",
  refinements = "refinements",
  showlanguage = "showlanguage",
  showtoolbar = "showtoolbar",
  showmenubar = "showmenubar",
  showbreadcrumbs = "showbreadcrumbs",
  singlepagebreadcrumbs = "singlepagebreadcrumbs",
  showsubtopprocesses = "showsubtopprocesses",
  simplebreadcrumbs = "simplebreadcrumbs",
  dockpanandzoom = "dockpanandzoom",
  docknavigator = "docknavigator",
  dockpages = "dockpages",
  dockstencil = "dockstencil",
  dockplanner = "dockplanner",
  dockpivot = "dockpivot",
  dockchatbot = "dockchatbot",
  usedialogs = "usedialogs",
  editdialogwidth = "editdialogwidth",
  shapesleftside = "shapesleftside",
  showquickshapes = "showquickshapes",
  quickshapesstyleinherit = "quickshapesstyleinherit",
  allownegativecoordinates = "allownegativecoordinates",
  showhyperlinkmarker = "showhyperlinkmarker",
  semmongoserverurl = "semmongoserverurl",
  usemongo = "usemongo",
  usemongosso = "usemongosso",
  usegraph = "usegraph",
  semconnecttoken = "semconnecttoken",
  dbname = "dbname",
  repository = "repository",
  SemTalkStatus = "SemTalkStatus",
  autosaveSemTalk = "autosaveSemTalk",
  autoComplete = "autoComplete",
  shapestyle = "shapestyle",
  guifont = "guifont",
  font = "font",
  fontsize = "fontsize",
  semanticsserver = "semanticsserver",
  semanticscorpus = "semanticcorpus",
  semanticsdistance = "semanticsdistance",
  tikaserver = "tikaserver",
  aiserviceserver = "aiserviceserver",
  aiservicemodel = "aiservicemodel",
  aiservicetemperature = "aiservicetemperature",
  applicationid = "applicationid",
  authority = "authority",
  scopes = "scopes",
  termsetgroup = "termsetgroup",
  termset = "termset",
  termsetroot = "termsetroot",
  termsetassoc = "termsetassoc",
  termseturl = "termseturl",
  m365group = "m365group",
  teamid = "teamid",
  channelid = "channelid",
  planid = "planid",
  theme = "theme",
  backgroundColor = "backgroundColor",
  userDefTheme = "userDefTheme",
  themeStyle = "themeStyle",
  iconcolor = "iconcolor",
  drawingbackgroundcolor = "drawingbackgroundcolor",
  textcolor = "textcolor",
  role = "role",
  autorefresh = "autorefresh",
  history = "history",
  historypos = "historypos",
  panzoom = "panzoom",
  panzoomX = "panzoomX",
  panzoomY = "panzoomY",
  pages = "pages",
  navigator = "navigator",
  navigatorX = "navigatorX",
  navigatorY = "navigatorY",
  navigatorW = "navigatorW",
  navigatorH = "navigatorH",
  planner = "planner",
  plannerX = "plannerX",
  plannerY = "plannerY",
  stencil = "stencil",
  stencilX = "stencilX",
  stencilY = "stencilY",
  stencilWidth = "stencilWidth",
  stencilHeight = "stencilHeight",
  search = "search",
  searchX = "searchX",
  searchY = "searchY",
  pivot = "pivot",
  pivotX = "pivotX",
  pivotY = "pivotY",
  width = "width",
  height = "height",
  chatbot = "chatbot",
  chatbotX = "chatbotX",
  chatbotY = "chatbotY",
  chatbotWidth = "chatbotWidth",
  chatbotHeight = "chatbotHeight",
  shapescale = "shapescale",
  resizeall = "resizeall",
  quickedit = "quickedit",
  sharepointrepository = "sharepointrepository",
  sharepointlibrary = "sharepointlibrary",
  sharepointfolder = "sharepointfolder",
  sharepointlibrarysite = "sharepointlibrarysite",
  sharepointdocumentcolumns = "sharepointdocumentcolumns",
  sharepointlibraryfixed = "sharepointlibraryfixed",
  sharepointoverrideswebpartsetting = "sharepointoverrideswebpartsetting",
  servicesconstr = "servicesconstr",
  servicesserver = "servicesserver",
  servicessite = "servicessite",
  servicesdatabase = "servicesdatabase",
  servicesservertype = "servicesservertype",
  breports = "breports",
  approved = "approved",
  printscale = "printscale",
  printpageformat = "printpageformat",
  printoverlays = "printoverlays",
  printcontrols = "printcontrols",
  printlandscape = "printlandscape",
  printtitle = "printtitle",
  printx0 = "printx0",
  printy0 = "printy0",
  printpageselector = "printpageselector",
  printborder = "printborder",
  filedialogcolumns = "filedialogcolumns",
  pubdialogcolumns = "pubdialogcolumns",
  isusertask = "isusertask",
  // logourl = "logourl",
  chatgpt = "chatgpt",
  chatgptpagecontent = "chatgptpagecontent",
  chatgptmodelcontent = "chatgptmodelcontent",
  chatgptcontentvisible = "chatgptcontentvisible",
  chatgptshowquestions = "chatgptshowquestions",
  chatgptpersistchats = "chatgptpersistchats",
  chatgptbpmnpreview = "chatgptbpmnpreview",
  chatgptquestion = "chatgptquestion",
  chatgptprompts = "chatgptprompts",
  chatgptsystemprompt = "chatgptsystemprompt",
  chatgptsystemprompttemplate = "chatgptsystemprompttemplate",
  chatgptsystemprompttext = "chatgptsystemprompttext",
  chatfilterbyuser = "chatfilterbyuser",
  chatfilterbymodel = "chatfilterbymodel",
  chatopenchatmodel = "chatopenchatmodel",
  chatgpthistory = "chatgpthistory",
  chats = "chats",
  chatid = "chatid",
  lru = "lru",
  showwelcome = "showwelcome",
  filename = "filename",
  usesimulationcoloring = "usesimulationcoloring",
  headerfooterfields = "headerfooterfields",
  showheaderfooterfields = "showheaderfooterfields",
  citfimConfig = "citfimConfig",
  semantictoolstext = "semantictoolstext",
  nlp_site = "nlp_site",
  nlp_library = "nlp_library",
  versioncount = "versioncount",
  autosaverepository = "autosaverepository",
  isplannerenabled = "isplannerenabled",
  ribbon = "ribbon",
  toolbar = "toolbar",
  isreflexivelinks = "isreflexivelinks",
  autoextend = "autoextend",
  autoscroll = "autoscroll",
  gridsize = "gridsize",
  extendParentsOnMove = "extendParentsOnMove",
  extendParentsOnAdd = "extendParentsOnAdd",
  resizecontainer = "resizecontainer",
  splitenabled = "splitenabled",
  rotationEnabled = "rotationEnabled",
  imagebundles = "imagebundles",
  layout = "layout",
  exportconnections = "exportconnections",
  exportlibraries = "exportlibraries",
  semmongoserverurlBackup = "semmongoserverurlBackup",
  reportremote = "reportremote",
  reportmerged = "reportmerged",
  reportmultiple = "reportmultiple",
  reporttemplate = "reporttemplate",
  searchremote = "searchtremote",
  searchmerged = "searchmerged",
  searchmultiple = "searchmultiple",
  searchtemplate = "searchtemplate",
  usesemanticsearch = "usesemanticsearch",
  isdoubleclickinplace = "isdoubleclickinplace",
  isconnectimage = "isconnectimage",
  warnsize = "warnsize",
  chatgptprompt = "chatgptprompt",
  showswimlaneinbreadcrumbs = "showswimlaneinbreadcrumbs",
  showswimlanelabels = "showswimlanelabels",
  swimlanespacing = "swimlanespacing",
  sharepointsitesearchsquery = "sharepointsitesearchsquery",
  sharepointlastdrive = "sharepointlastdrive",
  iconheight = "iconheight",
  iconwidth = "iconwidth",
  linklabelwidth = "linklabelwidth",
  textlabelwidth = "textlabelwidth",
  portalinstantrefine = "portalinstantrefine",
  portalstartdiagram = "portalstartdiagram",
  portalstartfile = "portalstartfile",
  portalribbon = "portalribbon",
  portalmode = "portalmode",
  portalforcestartdiagram = "portalforcestartdiagram",
  isoffice365 = "isoffice365",
  scrolltovisibleedge = "scrolltovisibleedge",
  staysignedin = "staysignedin",
  autosave = "autosave",
  autocheckout = "autocheckout",
  useAwareness = "useAwareness",
  savechangelog = "savechangelog",
  useSuggestions = "useSuggestions",
  autosavepng = "autosavepng",
  portalbackend = "portalbackend",
  portalconnection = "portalconnection",
  portaldb = "portaldb",
  portallib = "portallib",
  publishingoptions = "publishingoptions",
  enabledashboards = "enabledashboards",
  lastdashboard = "lastdashboard",
  sapr3activeid = "sapr3activeid",
  workflowdebugStepper = "workflowdebugStepper",
  workflowkeepsession = "workflowkeepsession",
  workflowenableConnectToken = "workflowenableConnectToken",
  workflowinputModerator = "workflowinputModerator",
  workflowinputredflags = "workflowinputredflags",
  workflowoutputModerator = "workflowoutputModerator",
  workflowoutputredflags = "workflowoutputredflags",
  workflowshowVariables = "workflowshowVariables",
  workflowruntimeInfo = "workflowruntimeInfo",
  forcenew = "forcenew"
}
